import {
  DialogContent,
  Grid,
  Button,
  makeStyles,
  withWidth,
} from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import FullScreenDialog from "../../../components/FormDialog/FormDialog";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
  },
  headerPages: {
    fontWeight: 700,
    color: "#212121",
    fontSize: 16,
    marginTop: 15,
  },
  description: {
    fontSize: 12,
    color: "#757575",
  },
}));

function TermInfo(props) {
  const classes = useStyles();
  const { title, order, width, proceed } = props;
  const [openDialog, setOpenDialog] = React.useState(true);

  const handleCloseDialog = () => {
    setOpenDialog(false);
    proceed();
  };

  return (
    <div>
      <FullScreenDialog
        disableBackdropClick
        maxWidth="md"
        fullScreen={width === "xs"}
        title={props.title}
        scroll="body"
        open={openDialog}
        HiddenCloseIcon
      >
        <DialogContent style={{ padding: "24px", minWidth: 620 }}>
          <Grid container>
            <Grid item xs={12}>
              <div className={classes.headerPages}>
                Informasi Penarikan Saldo
              </div>
              <div className={classes.headerPages}>Tujuan penarikan</div>
              <div className={classes.description}>
                Saldo hanya dapat ditarik ke rekening bank. Penarikan ke dompet
                digital tidak akan di proses
              </div>
              <div className={classes.headerPages}>Minimum Penarikan</div>
              <div className={classes.description}>
                BCA, BNI, BRI, Mandiri - Rp10.000
              </div>
              <div className={classes.description}>Bank Lain : Rp50.000</div>
              <div className={classes.headerPages}>Maksimum Penarikan</div>
              <div className={classes.description}>
                Maks. Rp50 miliar dalam sekali penarikan ke semua bank
              </div>
              <div className={classes.description}>
                Maks. 5 kali penarikan per hari
              </div>
              <div className={classes.headerPages}>Biaya Admin</div>
              <div className={classes.description}>
                BCA, BNI, dan Mandiri : Tidak dikenakan biaya admin <br /> BRI :
                Rp1.000 <br /> Bank lain : Rp2.900 <br /> Saldo yang dicairkan
                akan dikurangi biaya admin sesuai dengan ketentuan <br /> Biaya
                admin tetap dipotong jika terjadi kegagalan penarikan saldo
              </div>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                style={{ marginTop: 20 }}
              >
                {" "}
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => {
                    handleCloseDialog();
                  }}
                >
                  Mengerti
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </FullScreenDialog>
    </div>
  );
}

TermInfo.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};
export function showTermInfo(title, order, handleGetList, options = {}) {
  return createConfirmation(confirmable(withWidth()(TermInfo)))({
    title,
    order,
    handleGetList,
    ...options,
  });
}
